import bildJa from '@/assets/icons/ja.svg';
import bildNein from '@/assets/icons/nein.svg';
import bildUberspringen from '@/assets/icons/arrow.svg';

export const wishHeatpumpAnswers = [
    { name: 'Ja', available: true, value: 'ja', api: '19708', image: bildJa },
    { name: 'Nein', available: true, value: 'nein', api: '19709',  image: bildNein },
    { name: 'Überspringen', available: true, value: 'unknown', api: null,  image: bildUberspringen },
];

export const wishHeatpumpApi = {parameter: '17019', type: 'value_choice'};